import React from "react";
import {admissionService} from "../jwt/_services/configuration/admissionService";

export const admissionProvider = {
	getOptions,
	getItem,
};

async function getOptions(customFilter) {
	try {
		const listItems = await admissionService.search(0,100, customFilter);
		return listItems.data.map((itemData) => {
			const {id, code, name} = itemData
			return (
				{
					id: id,
					value: code,
					label: <div><label>{name}</label></div>
				}
			)
		});
	} catch (error) {
		console.log(error.message)
	}
}

async function getItem(id) {
	try {
		const item = await admissionService.getItem(id);

		return (
			{
				id: item.id,
				value: item.code,
				label: <div><label>{item.name}</label></div>
			}
		);
	} catch (error) {
		console.log(error.message)
	}
}